module.exports = __webpack_public_path__ + "videos/jp_animate.30e382e.mp4";